<template>
  <div class="foot-container" ref="foot">
    <div class="foot w-100 flex align-center justify-between">
      <div class="foot_left flex flex-direction align-start">
        <div class="foot_left_blod">求助与联系</div>
        <span class="foot_left_text" v-if="!this.$store.state.isMobile">
          <div class="foot_left_text">大会信息咨询热线：0755-28565555</div>
        </span>
        <span class="foot_left_text" v-if="this.$store.state.isMobile">
          <div class="foot_left_text">大会信息咨询热线：0755-28565555</div>
        </span>

        <div class="foot_left_text pc">大会官方邮箱：HPDC2022@huawei.com</div>
        <div class="foot_left_text wap">大会官方邮箱：HPDC2022@huawei.com</div>
      </div>
      <div class="foot_right flex flex-direction">
        <div class="follow_us">
          关注我们
          <div class="follow_icon">
            <div class="follow_icon_box cs flex align-center justify-center">
              <img
                class="icon"
                :src="pic1IconUrl"
                @mouseenter="showType = 'WeChat'"
                @mouseleave="showType = ''"
                @click="toHypers('微信公众号')"
              />
              <div
                :class="{ hoverQrcode: showType == 'WeChat' }"
                class="qrcode"
              >
                <div class="content flex align-center justify-center">
                  <img
                    class="qr_img"
                    src="../assets/images/foot/wxqrcode.a24ddcf4.jpg"
                  />
                </div>
              </div>
            </div>
            <div class="follow_icon_box cs flex align-center justify-center">
              <img
                class="icon"
                :src="pic2IconUrl"
                @mouseenter="showType = 'app'"
                @mouseleave="showType = ''"
                @click="toHypers('APP')"
              />
              <div :class="{ hoverQrcode: showType == 'app' }" class="qrcode">
                <div class="content flex align-center justify-center">
                  <img
                    class="qr_img"
                    src="@/assets/images/foot/appqrcode.2646c369.jpg"
                  />
                </div>
              </div>
            </div>
            <div class="follow_icon_box cs flex align-center justify-center">
              <img
                class="icon"
                :src="pic3IconUrl"
                @click="
                  didClick_weibo();
                  toHypers('微博');
                "
              />
            </div>
          </div>
        </div>
        <div class="contact_us">
          <div class="contact_us_item" @click="didClick_text('lxwm')">
            联系我们
          </div>
          |
          <div class="contact_us_item" @click="didClick_text('flsm')">
            法律声明
          </div>
          |
          <div class="contact_us_item" @click="didClick_text('ysbh')">
            隐私保护
          </div>
        </div>
        <div class="copyright">
          版权所有 <span>©</span> 华为技术有限公司 1998-2022
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {
      footHight: 0,
      pic1IconUrl: require("../assets/images/foot/pic1.png"),
      pic2IconUrl: require("../assets/images/foot/pic2.png"),
      pic3IconUrl: require("../assets/images/foot/pic3.png"),
      showType: "",
      weiboUrl: "https://weibo.com/u/7577602333?from=myfollow_all&is_all=1",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.footHight = this.$refs["foot"].offsetHeight;
    });
  },
  methods: {
    didClick_weibo() {
      window.open(this.weiboUrl);
    },
    didClick_text(type) {
      switch (type) {
        case "lxwm":
          window._hw("send", "action", "index_contact_us"); //用户点击“联系我们”按钮
          window._hw("send", "action", "index_contact_us_click"); //开发者大会首页_点击查看更多+查看全部
          window.open("https://www.huawei.com/cn/contact-us");
          break;
        case "ysbh":
          this.$router.push({
            name: "privacy",
            params: {},
          });
          break;
        case "flsm":
          this.$router.push({
            name: "legal",
            params: {},
          });
          break;
      }
    },
    //埋码
    toHypers(name) {
      window._hw("send", "action", "index_follow_us_click", {
        social_media_name: name,
      });
      this.$emit("setAccept", 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc {
  display: none;
}

.wap {
  display: none;
}
.foot-container {
}
.foot {
  font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC";
  font-weight: 400;
  background: #f4f4f4;
  .contact_us {
    display: flex;

    .contact_us_item {
      cursor: pointer;
    }
  }

  .copyright {
    color: #999999;
  }
}

@media screen and (min-width: 992px) {
  .pc {
    display: block;
  }
  //foot begin
  .foot {
    //margin-top: 60px;
    font-size: 16px;
    padding: 20px 160px 22px;

    .follow_us {
      display: flex;
      align-items: center;

      .follow_icon {
        display: flex;

        .follow_icon_box {
          width: 34px;
          height: 34px;
          position: relative;
          border-radius: 7px 7px 7px 7px;
          border: 1px solid #999999;
          margin-left: 11px;

          .qrcode {
            display: none;
          }

          &:nth-child(1) {
            .icon {
              width: 22px;
              height: 17px;
            }
          }

          &:nth-child(2) {
            .icon {
              width: 20px;
              height: 24px;
            }
          }

          &:nth-child(3) {
            .icon {
              width: 21px;
              height: 20px;
            }
          }

          .hoverQrcode {
            display: block;
            position: absolute;
            top: -160px;
            left: -75px;
            width: 150px;
            height: 150px;
            background: #ffffff;
            box-shadow: 0 0 60px 0 rgba(191, 191, 191, 0.5);
            z-index: $z-index-foot;

            .top {
              width: 100%;
              height: 30px;
              padding: 5px 10px;
              border-radius: 10px 10px 0 0;
              background-color: rgba(0, 0, 0, 0.1);

              .close-img {
                width: 20px;
                height: 20px;
              }
            }

            .content {
              width: 150px;
              height: 150px;

              .qr_img {
                width: 140px;
                height: 140px;
              }
            }

            .desc {
              width: 100%;
              height: 20px;
              color: #999999;
              font-size: 15px;
              margin: 0 auto;
            }
          }
        }
      }
    }

    .foot_left {
      font-size: 16px;
      color: #666666;

      .foot_left_blod {
        font-size: 18px;
        color: #000000;
        font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC";
        font-weight: 400;
      }
    }

    .foot_right {
      //width: 400px;
      margin-right: 5px;

      //img {
      //  width: 20px;
      //  height: 20px;
      //  border: 1px solid #c9c9c9;
      //  padding: 3px;
      //  margin-left: 5px;
      //  border-radius: 5px;
      //}
    }
  }
}

//foot end
@media screen and (max-width: 992px) {
  .wap {
    display: block;
  }
  //foot begin
  .foot {
    text-align: center;
    padding-bottom: 50px;
    padding-top: 50px;
    display: flex;
    flex-direction: column;

    .foot_left {
      width: 100%;

      .foot_left_blod {
        width: 100%;
        font-size: 28px;
        font-weight: bolder;
        margin-bottom: 30px;
        color: #000000;
      }

      .foot_left_text {
        width: 100%;
        font-size: 22px;
        color: #666666;
      }
    }

    .foot_right {
      width: 100%;
      margin-top: 60px;
      font-size: 22px;
      text-align: center;

      .follow_us {
        font-size: 24px;
        width: 100%;
        margin-bottom: 6px;

        .follow_icon {
          display: flex;
          justify-content: center;
          flex-wrap: nowrap;
          width: 100%;
          margin-top: 6px;

          .follow_icon_box {
            margin-left: 5px;
            padding: 3px;
            width: 50px;
            height: 50px;
            border: 1px solid #c9c9c9;
            position: relative;
          }

          .follow_icon_box {
            border-radius: 5px;

            .qrcode {
              display: none;
            }

            .hoverQrcode {
              width: 200px;
              height: 200px;
              display: block;
              position: absolute;
              top: -220px;
              z-index: $z-index-foot;
              background: #ffffff;
              box-shadow: 0 0 60px 0 rgba(191, 191, 191, 0.5);

              .content {
                width: 200px;
                height: 200px;

                .qr_img {
                  width: 200px;
                  height: 200px;
                }
              }
            }

            &:nth-child(1) {
              .icon {
                width: 34px;
                height: 26px;
              }
            }

            &:nth-child(2) {
              .icon {
                width: 30px;
                height: 36px;
              }
            }

            &:nth-child(3) {
              .icon {
                width: 30px;
                height: 30px;
              }
            }
          }
        }
      }

      .contact_us {
        width: 100%;
        margin-bottom: 14px;
        font-size: 22px;
        color: #666666;
        justify-content: center;
      }

      .copyright {
        width: 100%;
        font-size: 22px;

        span {
          font-family: LarkEmojiFont, LarkChineseQuote, -apple-system,
            BlinkMacSystemFont, Helvetica Neue, Tahoma, PingFang SC,
            Microsoft Yahei, Arial, Hiragino Sans GB, sans-serif,
            Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
        }
      }
    }
  }
  //foot end
}
</style>
